"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Padding = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
function Padding(props) {
    var size = props.size, x = props.x, y = props.y, top = props.top, left = props.left, bottom = props.bottom, right = props.right, children = props.children, _a = props.width, width = _a === void 0 ? 'auto' : _a, _b = props.style, style = _b === void 0 ? {} : _b, testId = props.testId;
    var styles = (0, tslib_1.__assign)({ boxSizing: 'border-box', paddingTop: top || y || size, paddingLeft: left || x || size, paddingRight: right || x || size, paddingBottom: bottom || y || size, width: width }, style);
    return (React.createElement("div", { style: styles, "data-testid": testId }, children));
}
exports.Padding = Padding;
//# sourceMappingURL=index.js.map